import React from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { InfoIcon } from 'ui-components/components/info-icon';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FlexRow } from 'ui-components/components/flex';

import { messages } from './messages';

import style from './additional-items-row-group-header-content.module.less';

export const AdditionalItemsRowGroupHeaderContent = () => {
  return (
    <FlexRow className={style['additional-items-row-group-header-content']}>
      <Text textType={TextType.Label} value={messages.additionalItemsHeader} />
      <InfoIcon
        color={THEME_CONSTANTS.unstyled}
        size='large'
        tooltipText={<Text textType={TextType.Caption} value={messages.additionalItemsTooltip} />}
      />
    </FlexRow>
  );
};
